import React, { type ChangeEvent, type KeyboardEvent } from "react";
import { InputV2 } from "src/components/InputV2/InputV2.tsx";
import { BaseInputV2Adornment } from "src/components/BaseInputV2/BaseInputV2Adornment.tsx";

export const SearchBar = ({
  placeholder,
  searchValue,
  onReset,
  onChange,
}: {
  placeholder?: string;
  searchValue?: string;
  onReset?: () => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}) => {
  const handleKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    // do not propagate key up event to 'list navigation' key up handler
  };
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
    // do not propagate key up event to 'list navigation' key down handler
  };

  return (
    <InputV2
      placeholder={placeholder}
      onKeyUp={handleKeyUp}
      onKeyDown={handleKeyDown}
      startAdornment={
        <BaseInputV2Adornment>
          <i className="icon-15-search" />
        </BaseInputV2Adornment>
      }
      endAdornment={
        searchValue && (
          <BaseInputV2Adornment isAction={true} onClick={onReset}>
            <i className="icon-15-clear_x" />
          </BaseInputV2Adornment>
        )
      }
      onChange={onChange}
      value={searchValue}
    />
  );
};
